module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-486e04847e323a1e5234016b8172b906.png";